
const ACCESS_TOKEN = 'ACCESS_TOKEN';
const AUTHENTICATION_INFO = 'AUTHENTICATION_INFO';
const USER_VIEW_PERMISSION_TREE = 'USER_VIEW_PERMISSION_TREE';
const USER_PAGE_BUTTONS = 'USER_PAGE_BUTTONS';

export {
  ACCESS_TOKEN, AUTHENTICATION_INFO, USER_VIEW_PERMISSION_TREE, USER_PAGE_BUTTONS,
};
